import styled from 'styled-components'
import { Grid } from 'components/grid'

export const Container = styled(Grid)`
    width: 100vw;
    height: 100dvh;
    place-items: center;
`